export enum AccessSharingRole {
  Viewer = 'VIEWER',
  Editor = 'EDITOR',
  Admin = 'ADMIN',
  Owner = 'OWNER',
}
